import { TableColumnsType } from "antd"
import { IDataOrganisation } from "@/types/dags"
import { useGetDataOrganisations } from "@/hooks/useDags"
import dayjs from "dayjs"
import TableCustom from "@components/table"

const OrganisationsPage = () => {
  const { data, isLoading } = useGetDataOrganisations()

  const columns: TableColumnsType<IDataOrganisation> = [
    {
      title: "Organisation Name",
      key: "organisation_name",
      dataIndex: "organisation_name",
    },
    {
      title: "Organisation Title",
      key: "organisation_title",
      dataIndex: "organisation_title",
    },
    {
      title: "Organisation Description",
      key: "organisation_description",
      dataIndex: "organisation_description",
    },
    {
      title: "Organisation Image URL",
      key: "organisation_image_url",
      dataIndex: "organisation_image_url",
      render: (text: string) => (
        <a href={text} target={"_blank"} rel="noopener noreferrer">
          {" "}Open{" "}
        </a>
      ),
    },
    {
      title: "Organisation Website",
      key: "organisation_website",
      dataIndex: "organisation_website",
      render: (text: string) => (
        <a href={text} target={"_blank"} rel="noopener noreferrer">
          {" "}Open{" "}
        </a>
      ),
    },
    {
      title: "Link",
      key: "link",
      dataIndex: "link",
      render: (text: string) => (
        <a href={text} target={"_blank"} rel="noopener noreferrer">
          {" "}Open{" "}
        </a>
      ),
    },
    {
      title: "Date Created",
      key: "dateCreated",
      dataIndex: "dateCreated",
      render: (text: Date) => dayjs(text).format("DD/MM/YYYY"),
    },
  ];

  return (
    <div>
      <TableCustom
        rowKey={"_id"}
        columns={columns}
        dataSource={data}
        loading={isLoading}
        size={"small"}
      />
    </div>
  );
};

export default OrganisationsPage
